module.exports = __webpack_public_path__ + "static/media/contactsyros.a9ad8dcc.png";